<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="800px">
    <v-card>
      <v-card-text class="text--primary">
        <v-autocomplete
          :items="moves"
          label="Select A Move"
          item-text="title"
          item-value="id"
          v-model="selectedMoveID"
          persistent-hint
          clearable
          hint="You can start typing to search"
          prepend-inner-icon="mdi-magnify"
        />
        <MoveDisplay v-if="selectedMoveID" :moveID="selectedMoveID" />
      </v-card-text>

      <v-card-actions v-if="selectedMoveID">
        <v-row justify="space-between" class="text-center">
          <v-col v-for="stat in selectedMove.rollableStats" :key="stat">
            <v-btn
              @click="makeMove(stat)"
              :disabled="!selectedMoveID"
              color="primary"
              ><v-icon left>mdi-dice-6-outline</v-icon>+{{ stat }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import MoveDisplay from '@/components/MoveDisplay.vue';

  export default {
    name: 'MovesDialog',
    props: ['value'],
    components: {MoveDisplay},
    watch: {
      value() {
        this.reset();
      },
    },
    computed: {
      ...mapState('move', ['moves', 'movesCategories']),
      ...mapGetters('move', ['moveByID']),
      selectedMove() {
        return this.moveByID(this.selectedMoveID);
      },
    },
    methods: {
      makeMove(stat) {
        this.$store.dispatch('move/rollMove', {
          moveTitle: this.selectedMove.title,
          stat: stat,
          wh: this.selectedMove.weakHit.html,
          sh: this.selectedMove.strongHit.html,
          m: this.selectedMove.miss.html,
        });
        this.close();
      },
      close() {
        this.reset();
        this.$emit('input', false);
      },
      reset() {},
    },
    data() {
      return {
        selectedMoveID: '',
      };
    },
  };
</script>
